import { gql } from "@apollo/client";


export const CREATE_INVITE_LINK = gql`
    mutation CreateInviteLink($email: String!, $role: UserRole!, $size: UserSize!) {
        createInviteLink(email: $email, role: $role, size: $size) {
            id
            createdAt
            updatedAt
            code
            email
            role
            size
            companyId
            isUsed
            usedById
        }
    }
`;